import naja from 'naja';
import Popover from "bootstrap.native/src/components-v4/popover-native";
import {genUuid} from "../helpers";

export default class ConfirmExtension {

	constructor(naja) {
		naja.addEventListener('init', (e) => {
			document.addEventListener('click', (e) => {
				this.processElement(e, e.target)
			});
		});

		naja.addEventListener('interaction', (e) => {
			this.processElement(e, e.element);
		});
	}

	processElement(e, element) {
		if (element.hasAttribute('data-confirm')) {
			e.preventDefault();
			let elementToShowPopover = null;
			if (element.hasAttribute('data-confirm-element-selector')) {
				const selector = element.getAttribute('data-confirm-element-selector');
				elementToShowPopover = document.querySelector(selector);
			}

			this.showTooltip(element, elementToShowPopover);
		}
	}

	showTooltip(element, elementToShowPopover = null) {
		elementToShowPopover = elementToShowPopover || element;
		if (!elementToShowPopover.popover) {
			const message = element.getAttribute('data-confirm');
			const title = element.getAttribute('data-confirm-title') || 'Opravdu?';
			const btnYesTitle = element.getAttribute('data-confirm-yes') || 'Ano';
			const btnNoTitle = element.getAttribute('data-confirm-no') || 'Ne';
			const popoverPlacement = element.getAttribute('data-confirm-placement') || 'bottom';

			const uniqueId = genUuid();

			const popover = new Popover(
				elementToShowPopover,
				{
					title,
					content: `<p>${message}</p>`,
					trigger: 'manual',
					placement: popoverPlacement,
					template: `<div class="popover custom-class" role="tooltip">`
						+ '<div class="arrow"></div>'
						+ '	<h3 class="popover-header"></h3>'
						+ '	<div class="popover-body"></div>'
						+ '	<div class="popover-footer">'
						+ `		<button type="button" class="btn btn-primary btn-sm" data-confirm-id="confirm_${uniqueId}" data-confirm-btn="yes">${btnYesTitle}</button>`
						+ `		<button type="button" class="btn btn-secondary btn-sm" data-confirm-id="confirm_${uniqueId}" data-confirm-btn="no">${btnNoTitle}</button>`
						+ '	</div>'
						+ '</div>'
				},
			);

			popover.show();

			setTimeout(() => {
				document.querySelectorAll(`[data-confirm-id="confirm_${uniqueId}"][data-confirm-btn]`).forEach(btnEl => {
					btnEl.addEventListener('click', (e) => {
						if (e.target.getAttribute('data-confirm-btn') === 'yes') {
							const attribute = element.getAttribute('data-confirm');
							element.removeAttribute('data-confirm');
							element.click();
							element.setAttribute('data-confirm', attribute);

							this.destroyTooltip(elementToShowPopover);
						} else {
							this.destroyTooltip(elementToShowPopover);
						}
					});
				});
			}, 50);
		}
	}

	destroyTooltip(element) {
		if (element.Popover) {
			element.Popover.dispose();
		}
	}
}